

export default class BullBullConst
{
    public static readonly TABLE_MODULE_NAME = "BankerBullBullTableModule";
    public static readonly MORE_MODULE_NAME = "BullBullMoreModule";
    public static readonly MATCH_MODULE_NAME = "BullBullMatchModule";

    public static readonly PREFAB_RES_PATH_BASE = "package/bullbull/";


    /**
     * 最大人数
     */
    static MAX_SEAT_NUM = 8;              


    public static readonly POKER_NUMBER_MAP : { [key:string] : number } = {

        "A":1, "2":2, "3":3, "4":4, "5":5, "6":6, "7":7, "8":8, "9":9, "10":10,
        "J":11, "Q":12, "K": 13
    }

    public static readonly POKER_COLOR_MAP : { [key:string] : number } = {

        "S":4, "H":3, "C":2,"D":1 //黑红梅方
    }


}